import GrayCard from "components/gray-card";
import TextInput from "components/inputs/text-input";
import Radio from "components/radio";
import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  title: string;
  channelName: string;
  label: string;
  placeholder: string;
  onChangeInput: (value: string) => void;
  value: string;
}
const StoreItem = ({
  title,
  channelName,
  label,
  placeholder,
  onChangeInput,
  value
}: IProps) => {
  const [radio, setRadio] = useState("no");
  return (
    <GrayCard title={title}>
      <Typography weight="medium" color={Colors.grey400} mb="1.6">
        Does The Artist have a {channelName}?
      </Typography>
      <RadioItem>
        <Radio
          value={radio === "no"}
          onClick={() => {
            setRadio("no");
            onChangeInput("");
          }}
        />
        <Typography>No, There’s no existing {channelName}.</Typography>
      </RadioItem>
      <RadioItem>
        <Radio
          value={radio === "yes"}
          onClick={() => {
            setRadio("yes");
          }}
        />
        <Typography>Yes, There’s no existing {channelName}.</Typography>
      </RadioItem>
      {radio === "yes" ? (
        <InputItem>
          <TextInput
            placeholder={placeholder}
            label={label}
            onChange={(e) => onChangeInput(e.target.value)}
            value={value}
          />
        </InputItem>
      ) : null}
    </GrayCard>
  );
};

export default StoreItem;

const RadioItem = styled.div`
  display: grid;
  grid-template-columns: 3% 96%;
  margin-bottom: 1.6rem;
  align-items: center;
  justify-content: space-between;
`;

const InputItem = styled.div`
  padding-top: 0.8rem;
`;
